import { QuestionIsNextMorning } from "@/components/features/items/edit/option/_shared/ui/components/is-next-morning";

import { useOptionIsNextMorning } from "./hooks";

export const QuestionOptionIsNextMorning = () => {
	const {
		useAsSubOption,

		isNextMorning,
		onSetIsNextMorning,

		isEdited,
		hasError,
	} = useOptionIsNextMorning();

	return (
		<QuestionIsNextMorning
			useAsSubOption={useAsSubOption}
			isNextMorning={isNextMorning}
			onSetIsNextMorning={onSetIsNextMorning}
			hasError={hasError}
			isEdited={isEdited}
		/>
	);
};

QuestionOptionIsNextMorning.displayName = "QuestionOptionIsNextMorning";
